<script>
  import NavbarSuccess from "../NavbarSuccess.svelte";
  import DeliverableContainer from "../containers/DeliverableContainer.svelte";
  import {
    Table,
    Collapse,
    Spinner,
    Card,
    CardBody,
    Button
  } from "sveltestrap";
  import DataSpinner from "../Spinner.svelte";
  import Icon from "svelte-awesome";
  import { chevronLeft, chevronRight, arrowUp } from "svelte-awesome/icons";
  import { onMount, setContext } from "svelte";
  import axios from "axios";

  const urlParams = new URLSearchParams(window.location.search);
  const searchquery = urlParams.get("q");
  let isOpen = false;
  let isFetchingTeamOptions = false;
  let teamOptions = [];
  let selectedTeam =
    localStorage.getItem("team") === null ? "" : localStorage.getItem("team");
  let allDeliverableItems = null;
  let deliverableGroups = null;
  let priorities;
  let status;
  let flag = false;
  let staticVariables;
  let isFetching = true;
  let scrollby = 3;
  let productionCollapse = false;
  let availableDeliverableItems = [];
  let filteredDeliverableItems = [];
  let deliverableItemFilters = [];

  let jobCards = [];

  let isAllColumnsSelected = false;
  let search = "";
  let leftArrow =
    window.location.origin + "/public/assets/images/arrow-left.png";
  let rightArrow =
    window.location.origin + "/public/assets/images/arrow-right.png";

  let showBackToTopButton = false;
  let jobBoardContainer = {};

  $: offset = 0;
  $: atStart = offset === 0;
  $: atEnd =
    offset <=
    paginationFactor * (availableDeliverableItems.length - scrollby) * -1;


  const paginationFactor = 175;
  const totalPaginationPixels = scrollby * paginationFactor;

  const move = direction => {
    if (direction > 0 && !atEnd) {
      offset -= totalPaginationPixels;
    } else if (direction < 0 && !atStart) {
      offset += totalPaginationPixels;
    }
  };

  let jobDetail;
  let filterDeliverable;

  if (searchquery != null) {
    search = searchquery;
  }

  setContext('jobBoard', {
    getAvailableDeliverableItems: () => availableDeliverableItems,
    getJobCards: () => jobCards,
  });

  onMount(async () => {
    isFetching = true;
    await getShownDeliverableItems();
    await getUser();
    await getJobCards().then(() => isFetching = false);
    await getTeam();
  });

  async function getShownDeliverableItems() {
    await axios
      .get("/jobBoardV2Api/GetShownDeliverableItems")
      .then(res => {
        availableDeliverableItems = res.data || [];
        isAllColumnsSelected = true;
        deliverableItemFilters = availableDeliverableItems.map(e => e.DeliverableItemId);
        filteredDeliverableItems = availableDeliverableItems;
      })
      .catch(console.warn);
  }

  async function getUser() {
    const response = await fetch("/authentication/GetUserDetails");
    const responseJson = await response.json();
    const user = responseJson.Result;
    if (user.Team === 100000005) {
      return;
    }

    selectedTeam = user.Team;
    localStorage.setItem("team", selectedTeam);
  }

  async function getJobCards() {
    await axios
      .get(`/jobboardapi/getDeliverables?&TeamId=${selectedTeam}&searchText=${search}`)
      .then(res => jobCards = res.data || [])
      .catch(console.warn);
  }

  async function getTeam() {
    isFetchingTeamOptions = true;
    const teamOptionsCache = localStorage.getItem('job_team_options');
    if (!!teamOptionsCache) {
      teamOptions = JSON.parse(teamOptionsCache || '[]');
      isFetchingTeamOptions = false;
      return Promise.resolve();
    }

    axios.get("/JobBoardApi/GetTeams")
      .then(res => {
        teamOptions = res.data || teamOptions;
        localStorage.setItem('job_team_options', JSON.stringify(teamOptions));
      })
      .catch(console.warn)
      .finally(() => isFetchingTeamOptions = false);
  }

  function handleChangeTeam(e) {
    selectedTeam = e.target.value;
    localStorage.setItem("team", selectedTeam);
    deliverableGroups = null;
    isFetching = true;
    getJobCards().then(() => isFetching = false);
  }

  function handleChangeContacts(e) {
    deliverableGroups = null;
    isFetching = true;
    getJobCards().then(() => isFetching = false);
  }

  function selectAllColumns(evt) {
    isAllColumnsSelected = evt.target.checked;
    if (isAllColumnsSelected) {
      deliverableItemFilters = availableDeliverableItems.map(e => e.DeliverableItemId);
    } else {
      deliverableItemFilters = [];
    }

    filteredDeliverableItems = availableDeliverableItems.filter(e => deliverableItemFilters.some(f => f === e.DeliverableItemId));
  }

  function toggleColumn(deliverableItemId, evt) {
    if (!evt.target.checked) {
      deliverableItemFilters = deliverableItemFilters.filter(e => e !== deliverableItemId);
    } else {
      deliverableItemFilters = [ ...deliverableItemFilters, deliverableItemId ];
    }

    isAllColumnsSelected = deliverableItemFilters.length >= availableDeliverableItems.length;
    filteredDeliverableItems = availableDeliverableItems.filter(e => deliverableItemFilters.some(f => f === e.DeliverableItemId));
  }

  function hideColumn(deliverableItemId) {
    deliverableItemFilters = deliverableItemFilters.filter(e => e !== deliverableItemId);

    isAllColumnsSelected = deliverableItemFilters.length >= availableDeliverableItems.length;
    filteredDeliverableItems = availableDeliverableItems.filter(e => deliverableItemFilters.some(f => f === e.DeliverableItemId));
  }

  function refreshJobList() {
    let status = document.getElementById("status").value;
    let updateDeliverableItemId = document.getElementById(
      "updateDeliverableItemId"
    ).value;
    let updateDeliverableId = document.getElementById("updateDeliverableId")
      .value;
    console.log(status);
    if (status == "2") {
      deliverableGroups
        .find(x => x.DeliverableItemId == updateDeliverableItemId)
        .Job.pop(x => x.DeliverableId == updateDeliverableId);
      deliverableGroups = deliverableGroups;
    }
  }

  function refreshContact() {
    let updateDeliverableId = document.getElementById("updateDeliverableId")
      .value;
    let updateDeliverableItemId = document.getElementById(
      "updateDeliverableItemId"
    ).value;

    axios
      .get(
        "/resourceapi/retrieveallresourceassigned?deliverableId=" +
          updateDeliverableId
      )
      .then(function(response) {
        let contacts = response.data;
        deliverableGroups
          .find(x => x.DeliverableItemId == updateDeliverableItemId)
          .Job.find(
            x => x.DeliverableId == updateDeliverableId
          ).ResourcesAssigned = contacts;
        deliverableGroups = deliverableGroups;
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  function handleEnterSearch(e) {
    if (e.keyCode === 13) {
      handleSearch();
    }
  }

  function handleSearch() {
    isFetching = true;
    getJobCards().then(() => isFetching = false);
  }

  function clearSearch() {
    search = "";
    isFetching = true;
    getJobCards().then(() => isFetching = false);
  }

  function refreshProjectManager() {
    var jobId = document.getElementById("jobId").value;

    var projectManager = document.getElementById("projectManager").value;
    deliverableGroups.forEach(function(item) {
      if (item.Job.find(x => x.JobID == jobId) != undefined) {
        item.Job.find(x => x.JobID == jobId).ProjectManager = projectManager;
      }
    });
  }

  function productionsChange() {
    getShownDeliverableItems();
  }

  function getDeliverablesNoRefresh() {
    isFetching = true;
    axios
      .get(getDeliverableFetchUrl())
      .then(function(response) {
        deliverableGroups = response.data;
        isFetching = false;
      })
      .catch(function(error) {
        console.log(error);
      });
  }

/** @see getDeliverables @see getDeliverablesNoRefresh */
function getDeliverableFetchUrl() {
  return "/jobboardapi/getDeliverables?&TeamId="+
    selectedTeam+
    "&filter="+
    availableDeliverableItems.map(e => e.DeliverableItemId)+
    "&searchtext="+
    search;
}

  function reloadJobBoard() {
    isFetching = true;
    return getJobCards().then(() => isFetching = false);
  }

  function backToTopClicked() {
    jobBoardContainer.scrollTo(0, 0);
  }

  function rightArrowClicked() {
    const columnMargin = 2;
    const scrollStep = document.querySelector(".deliverable-container").getBoundingClientRect().width + columnMargin;

    const jobBoardTable = document.querySelector('.job-board-container');
    jobBoardTable.scroll({
      left: jobBoardTable.scrollLeft + scrollStep,
      behavior: 'smooth',
    });
  }

  function leftArrowClicked() {
    const columnMargin = 2;
    const scrollStep = document.querySelector(".deliverable-container").getBoundingClientRect().width + columnMargin;

    const jobBoardTable = document.querySelector('.job-board-container');
    jobBoardTable.scroll({
      left: jobBoardTable.scrollLeft - scrollStep,
      behavior: 'smooth',
    });
  }

</script>

<style>
  .timesite-container {
    max-width: 1460px;
    margin: 0 auto;
  }
  .job-board-container {
    width: 100%;
    display: flex;
    height: 600px;
    overflow: auto;
    scroll-behavior: smooth;
  }
  .job-board-scrolled-container {
    background: #fff;
    display: flex;
    height: fit-content;
  }
  .job-board-container > div:nth-child(2) {
    height: fit-content;
  }
  .job-board-table-container {
    overflow: hidden;
    max-width: 1460px;
    position: relative;
  }
  .job-board-table {
    margin-left: 0;
    margin-top: 50px;
  }
  .left-arrow {
    width: 40px;
    height: 53px;
    background: #dcdde1;
    position: absolute;
    left: 0;
    z-index: 9;
    padding: 14px 10px;
  }
  .right-arrow {
    width: 40px;
    height: 53px;
    background: #dcdde1;
    position: absolute;
    right: 0;
    z-index: 9;
    padding: 15px 13px;
  }
  .job-board-filter {
    display: flex;
  }
  .job-board-filter span {
    padding-top: 8px;
    font-size: 15px;
    padding-right: 12px;
  }
  .job-board-filter select {
    display: block;
    width: 30%;
    height: calc(2.5rem + 2px);
    padding: 5px;
    border: 1px solid #ced4da;
    border-radius: 0;
    font-size: 13px;
    margin-left: 5px;
  }
  .searchbox-container {
    margin-top: 10px;
    display: flex;
    margin-left: 54px;
  }
  .searchbox-container input {
    padding: 8px 11px;
    margin-right: 11px;
    width: 31.3%;
    height: calc(2.5rem + 2px);
    color: #495057;
    border: 1px solid #ced4da;
    border-radius: 0;
    font-size: 13px;
  }

  .searchbox-container span {
    margin: 6px 20px 0px -26px;
    cursor: pointer;
    font-weight: bold;
  }

  .input-search {
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
    display: inline-block;
  }
  @media (max-width: 768px) {
    .timesite-container {
      width: 90%;
    }
    .job-board-table-container {
      width: 100%;
    }
    .job-board-filter select,
    .searchbox-container input {
      width: 300px;
    }
  }
  @media (max-width: 426px) {
    .timesite-container {
      width: 95% !important;
    }
  }
  @media (max-width: 320px) {
    .job-board-filter select,
    .searchbox-container input {
      width: 175px;
    }
  }
  .no-data {
    position: absolute;
    text-align: center;
    width: 100%;
    background: #fff;
    padding-top: 46px;
  }
  .no-data-def {
    position: absolute;
    width: 100%;
  }
  .no-data-def .no-data-content {
    z-index: -1;
    position: absolute;
    width: 150px;
    text-align: center;
    margin: 0 auto;
    left: 0;
    right: 0;
  }
  .no-data-content {
    width: 150px;
    height: 150px;
    margin: 0 auto;
    border-radius: 100%;
    /* background: #eff0f5; */
    background: #fff;
  }
  .no-data-content span {
    color: #868686;
    margin-top: 45px;
    font-size: 15px;
    display: block;
  }
  .no-data-content .fa {
    padding-top: 40px;
  }
  .fa-folder:before {
    color: #d1d1d1;
    font-size: 70px;
  }
</style>

<NavbarSuccess />
<div class="timesite-container">

  <div class="job-board-filter">
    <span>Team:</span>
    <select value={selectedTeam} on:change={handleChangeTeam}>
      {#if !isFetchingTeamOptions}
        {#each teamOptions as team}
          <option
            value={team.Value}
            selected={localStorage.getItem('team') === team.Value ? true : false}>
            {team.Label}
          </option>
        {/each}
      {:else}
        <select>
          <option />
        </select>
        <Spinner
          size="sm"
          style="position: absolute; margin-top: 15px; margin-left: 18px;" />
      {/if}
    </select>
    <div class="filter-btn">
      <!--<Button on:click={() => (productionCollapse = !productionCollapse)} >-->
      <Button
        disabled={isFetching ? true : false}
        style={isFetching ? 'cursor: not-allowed' : ''}>
        Filter
      </Button>
      <!--{#if productionCollapse}-->
      <div class="filter-option-container" />
      <div class="filter-option">
        <input
          type="checkbox"
          style="margin-top: 7px; margin-right: 5px"
          checked={isAllColumnsSelected}
          on:click={selectAllColumns} />
        <label>Show All</label>
        <div>
          {#each availableDeliverableItems as deliverableItem}
            <div>
              <input
                type="checkbox"
                style="margin-top: 7px; margin-right: 5px"
                bind:group={deliverableItemFilters}
                value={deliverableItem.DeliverableItemId}
                on:change={evt => toggleColumn(deliverableItem.DeliverableItemId, evt)} />
              <label style="margin-right: 10px">{deliverableItem.Name}</label>
            </div>
          {/each}
        </div>
      </div>
      <!--{/if}-->
    </div>
  </div>
  <div class="searchbox-container" style="display: flex;">
    <input type="text" bind:value={search} on:keyup={handleEnterSearch} />
    <span on:click={clearSearch}>x</span>
    <Button color="primary" on:click={handleSearch} class="search-btn">
      Search
    </Button>
  </div>
  <input type="text" hidden id="completed" value="" />
  <input type="text" hidden id="deliverableItemId" value="" />
  <input type="text" hidden id="deliverableId" value="" />
  <input type="text" hidden id="jobId" value="" />
  <input type="text" hidden id="projectManager" value="" />
  <input type="text" hidden id="filterDeliverable" value={availableDeliverableItems} />
  <input
    type="checkbox"
    hidden
    id="clickedFilter"
    on:click={async () => productionsChange()} />
  <input
    type="checkbox"
    hidden
    id="joblist-container"
    on:click={refreshJobList} />
  <input
    type="checkbox"
    hidden
    id="contact-refresh"
    on:click={refreshContact} />
  <input
    type="checkbox"
    hidden
    id="projectmanager-refresh"
    on:click={refreshProjectManager} />
  <div class="job-board-table-container">

    <div class="job-board-table">
      {#if jobCards.length > 0 && !isFetching}
        <div class="right-arrow" on:click={rightArrowClicked} >
          <img src={rightArrow} width="14" alt="right arrow" />
        </div>
        <div class="left-arrow" on:click={leftArrowClicked} >
          <img src={leftArrow} width="14" alt="left arrow" />
        </div>
      {/if}
      {#if isFetching}
        <div style="height:500px;background:transparent;position:relative">
          <DataSpinner />
        </div>
      {:else if jobCards.length > 0}
        <div class="job-board-container no-scroll" bind:this={jobBoardContainer} on:scroll={e => showBackToTopButton = e.target.scrollTop >= 100}>
          <div class="no-data-def">
            <div class="no-data-content">
              <!-- <i class="fa fa-folder" />
              <span>No Data Available</span> -->
            </div>
          </div>
          <div class="job-board-scrolled-container">
            {#each filteredDeliverableItems as deliverableItem}
              <DeliverableContainer
                {deliverableItem}
                {jobCards}
                on:hide={evt => hideColumn(evt.detail)}
                on:jobUpdated={reloadJobBoard} />
            {/each}
          </div>
        </div>
        <div style="z-index: 999; position: fixed; bottom: 40px; right: 40px;">
          {#if showBackToTopButton}
            <Button on:click={backToTopClicked}>
              <Icon data={arrowUp} />
            </Button>
          {/if}
        </div>
      {:else}
        <div class="job-board-container">
          <div class="no-data">
            <div class="no-data-content">
              <i class="fa fa-folder" />
              <span>No Data Available</span>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</div>
